export class SessaoViewModel {
    name!: string;
    token: string | undefined;
    email: string="" ;
    id!:string;
    role!:string;
    
  }
   